export default __webpack_public_path__ + "static/media/smart-btn-loader.375b78e7.svg";